<template>
  <div class="container page bind-card-page">
    <van-nav-bar :title="$t('setting.fill_bank')" class="nav-bar" :border="false">
      <template #left>
        <van-icon name="arrow-left" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main-content">
      <div class="form-tip">{{ $t('setting.fill_bank_tip') }}</div>

      <div class="form-card">
        <div class="form-row van-hairline--bottom">
          <span class="form-label">{{ $t('setting.username') }}</span>
          <input
            v-model="username"
            class="form-input"
            type="text"
            :placeholder="$t('setting.username_place')"
          />
        </div>
        <div class="form-row van-hairline--bottom">
          <span class="form-label">{{ $t('setting.band_name') }}</span>
          <input
            v-model="bank"
            class="form-input"
            type="text"
            :placeholder="$t('setting.band_name_tip')"
          />
        </div>
        <div class="form-row van-hairline--bottom">
          <span class="form-label">{{ $t('setting.branch_name') }}</span>
          <input
            v-model="bankfenhang"
            class="form-input"
            type="text"
            :placeholder="$t('setting.branch_name_tip')"
          />
        </div>
        <div class="form-row">
          <span class="form-label">{{ $t('setting.band_account') }}</span>
          <input
            v-model="bankid"
            class="form-input"
            type="text"
            :placeholder="$t('setting.band_account_tip')"
          />
        </div>
      </div>

      <p class="warn-text">{{ $t('setting.bank_warn') }}</p>

      <button class="submit-btn" @click="bindCard()">{{ $t('setting.bank_ok') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {},
      bankid: '',
      username: '',
      bank: '',
      bankfenhang: '',
      is_bind: false
    }
  },
  methods: {
    back() {
      return window.history.back()
    },
    bindCard() {
      if (this.is_bind) {
        this.$toast(this.$t('setting.bindinged'))
        return false
      }
      if (!this.username) {
        this.$toast.fail(this.$t('setting.username_place'))
        return false
      }
      if (!this.bank) {
        this.$toast.fail(this.$t('setting.band_name_tip'))
        return false
      }
      if (!this.bankfenhang) {
        this.$toast.fail(this.$t('setting.branch_name_tip'))
        return false
      }
      if (!this.bankid) {
        this.$toast.fail(this.$t('setting.band_account_tip'))
        return false
      }
      this.$http({
        method: 'post',
        data: {
          bankid: this.bankid,
          bank: this.bank,
          username: this.username,
          bankfenhang: this.bankfenhang,
          fhnumber: ''
        },
        url: 'user_set_bank'
      }).then(res => {
        if (res.code === 200) {
          this.$toast(res.msg)
          this.$router.push({ path: '/Setbank' })
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      })
    },
    getUserInfo() {
      this.$http({ method: 'get', url: 'user_info' }).then(res => {
        if (res.code === 200) this.userInfo = res.data
        else if (res.code === 401) this.$toast(res.msg)
      })
    },
    getUserBankInfo() {
      this.$http({ method: 'get', url: 'user_get_bank' }).then(res => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.is_bind = true
            this.bank = res.data.info.bankinfo
            this.bankfenhang = res.data.info.bankfenhang
            this.bankid = res.data.info.bankid
            this.username = res.data.info.username
          } else {
            this.is_bind = false
          }
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserInfo()
      this.getUserBankInfo()
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/base.css';

.bind-card-page {
  background: #f2f2f5;
}

.main-content {
  padding: 0.75rem;
}

.form-tip {
  padding: 0.25rem 0.25rem 0.75rem;
  font-size: 0.875rem;
  color: #666;
}

.form-card {
  background: #fff;
  border-radius: 0.625rem;
  overflow: hidden;
  box-shadow: 0 0.13333rem 0.2rem rgba(0, 0, 0, 0.04);
}

.form-row {
  display: flex;
  align-items: center;
  min-height: 3rem;
  padding: 0.75rem 0.875rem;
  box-sizing: border-box;
}

.form-label {
  flex-shrink: 0;
  width: 5rem;
  font-size: 0.9375rem;
  color: #333;
}

.form-input {
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  text-align: right;
  font-size: 0.9375rem;
  color: #333;

  &::placeholder {
    color: #bbb;
  }
}

.warn-text {
  margin: 0.75rem 0.25rem 0;
  font-size: 0.75rem;
  color: #999;
  line-height: 1.6;
}

.submit-btn {
  display: block;
  width: 100%;
  height: 3rem;
  margin-top: 1.25rem;
  border: none;
  border-radius: 1.5rem;
  color: #fff;
  font-size: 1.0625rem;
  font-weight: 600;
  background: linear-gradient(90deg, #f560cd, #8056e3);
}
</style>
